<script lang="ts" setup>
import { MediaImageFragment } from '~/api/graphql/generated'
import { HeadingType } from '~/components/atoms/Heading.vue'

defineProps<{
  image: MediaImageFragment | undefined
  title: string
  type?: string
  date?: string
  description: string
  link: {
    url: string
    target: string
    text: string
  }
  titleTag?: HeadingType
}>()
</script>
<template>
  <Card class="card-image" :link="link">
    <div class="image">
      <Image v-if="image" type="teaser" :entity="image" />
    </div>
    <template #sliding>
      <Heading :is="titleTag || 'h3'" :data="title" look="h3" />
      <span v-if="type" class="type f-18 f-medium">{{ type }}</span>
      <span v-if="date" class="date f-18">{{ date }}</span>
      <div class="description text-small" v-html="description" />
    </template>
  </Card>
</template>
<style lang="scss" scoped>
.card {
  display: grid;
  grid-template-columns: 54px auto 54px 48px;
  grid-template-rows: 40px auto 96px auto;
  @include hover {
    :deep(.image img) {
      transform: scale(1.1);
    }
  }

  :deep(.sliding-content) {
    margin-top: calc(-1 * var(--slide, 0));
    background-color: var(--c-white);

    grid-column: 1 / -1;
    padding: 24px 0 0 0;

    @include breakpoint(t) {
      grid-column: 1 / 3;
      grid-row: 3 / 5;
      padding: 32px 48px var(--slide, 0) 0;

      &:after {
        content: '';
        position: absolute;
        top: 100%;
        left: 0;
        width: 100%;
        height: 200px;
        background-color: var(--c-white);
      }
    }
  }
}

.image {
  grid-column: 1 / -1;
  grid-row: 1 / 4;

  position: relative;
  overflow: hidden;
  img {
    aspect-ratio: 1;
    @include transitions(transform);
  }
}
</style>
